import { render, staticRenderFns } from "./brandEdit.vue?vue&type=template&id=60d6b352&scoped=true"
import script from "./brandEdit.vue?vue&type=script&lang=js"
export * from "./brandEdit.vue?vue&type=script&lang=js"
import style0 from "./brandEdit.vue?vue&type=style&index=0&id=60d6b352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d6b352",
  null
  
)

export default component.exports